/** The job feature's URL segments, used by routes. */
export const JOB_SEGMENT = "jobs";
export const JOB_LIST_SEGMENT = "list";
export const JOB_SCHEDULE_SEGMENT = "schedules";

/** The job feature's full paths, used by navigation and links. */
export const JOB_PATH = `/${JOB_SEGMENT}`;
export const JOB_LIST_PATH = `${JOB_PATH}/${JOB_LIST_SEGMENT}`;
export const JOB_SCHEDULE_PATH = `${JOB_PATH}/${JOB_SCHEDULE_SEGMENT}`;
